import { getBaseRequestUrl, getToken } from './constants';
import { message } from "antd";

interface FilrResponse {
    retCode: number,
    retData: string,
    retMsg: string,
    success: boolean
}
interface File {
    uid?: string,
    name?: string,
    status?: string,
    response: FilrResponse,
    linkProps?: any
}
interface Upload {
    file: File,
    fileList: any,
    event: any
}

export function importPropsConfig(url: string, callback: any): object {
    let cfg = {
        name: 'file',
        action: getBaseRequestUrl() + url,
        headers: {
            authorization: getToken(),
        },
        onChange(info: Upload) {
            console.log(JSON.stringify(info, null, 2))
            if (info.file.status === 'done' && info.file.response.retCode === 200) {
                message.info({ content: `${info.file.name}导入${info.file.response.retData}`, duration: 8 });
                callback && callback(info)
            } else if (info.file.status === 'error' && info.file.response && info.file.response.retData) {
                message.error(`${info.file.response.retData}：${info.file.name}导入异常，请尝试重新导入`);
            } else if (info.file.status === 'error') {
                message.error("导入错误")
            }
        },
    }
    return cfg
}